//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../Features/Features.ShipDesign.PlateStockBuilder.js";
import "../no/Expression.js";
import "../no/Features.js";
let d=[[[0,"AnchorPoint",1,0],[1,"BuiltUpStockData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"PlateHeight",0,"Expression",0],[1,"PlateStockData",0,"Features.ShipDesign.PlateStockBuilder",0],[1,"ProfileStockData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[0,"SectionType",1,0]],[[[],"PopulateAnchorPointList",{},0,0],[["nNames"],"GetAvailableAnchorPointNames",{R_:{names:""}},0,0],[["bodyType"],"InheritStockProperties",{},1,0],[["bodyType"],"CompareSectionType",{R_:{bEqual:''}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.StiffenerStockBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StiffenerStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StiffenerStockBuilder.StockSectionType = Object.freeze({
    "Profile" : "Profile", "Plate" : "Plate", "BuiltUp" : "BuiltUp"});

export default SPLM;